import React from 'react';
import cn from './../../lib/bem';

import './button_component.scss';

const ButtonComponent = (props) => {
  const classes = cn('buttonComponent');

  return (
    <div className={classes()}>
      <button
        form={props.form}
        type={props.type}
        name={props.label}
        aria-label={props.label}
        className={classes(props.tipo)}
        disabled={props.disabled}
        onClick={props?.action}
      >
        {props.nombre}
      </button>
    </div>
  );
};

export default ButtonComponent;
